export default class Constants {
    public static readonly WS_URL = "wss://game.bobba.io/"

    public static readonly AVATAR_RESOURCES_URL = "//images.bobba.io/gordon/PRODUCTION-202006192205-424220153/";
    public static readonly FURNI_RESOURCES_URL = "//images.bobba.io/dcr/hof_furni/";
    public static readonly CATALOGUE_RESOURCES_URL = "//images.bobba.io/c_images/catalogue/";
    public static readonly TOP_STORY_RESOURCES_URL = "//images.bobba.io/c_images/Top_Story_Images/";
    public static readonly BADGE_RESOURCES_URL = "//images.bobba.io/c_images/album1584/";
}